import React from "react";
import { Spin } from "antd";
import { Drawer } from "antd5"
import moment from "moment";

const EventoCard = ({ evento, onClick }) => {
  const color = evento.color || "#9b9b9b";

  // Para tareas sin fecha no mostramos horario
  const horario = !evento.start
    ? null
    : evento.allDay
    ? "Todo el día"
    : `${moment(evento.start).format("HH:mm")} – ${moment(evento.end).format("HH:mm")}`;

  return (
    <div
      onClick={() => onClick(evento)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 12px",
        borderRadius: 8,
        cursor: "pointer",
        border: `1.5px solid ${color}30`,
        background: `${color}08`,
        marginBottom: 8,
        transition: "all 0.15s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = `${color}18`)}
      onMouseLeave={(e) => (e.currentTarget.style.background = `${color}08`)}
    >
      <div
        style={{
          width: 3,
          alignSelf: "stretch",
          borderRadius: 4,
          background: color,
          flexShrink: 0,
        }}
      />

      <div style={{ flex: 1, minWidth: 0 }}>
        {evento.leadNombre && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              marginBottom: 2,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: color,
                display: "inline-block",
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: 9,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                color,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {evento.leadNombre}
            </span>
          </div>
        )}

        <div
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: "#1a1a1a",
            textDecoration: evento.completado ? "line-through" : "none",
            opacity: evento.completado ? 0.5 : 1,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {evento.title}
        </div>

        {horario && (
          <div style={{ fontSize: 11, color: "#aaa", marginTop: 2 }}>
            {horario}
          </div>
        )}
      </div>

      {evento.completado && (
        <span
          style={{
            fontSize: 10,
            fontWeight: 600,
            color: "#52c41a",
            background: "#52c41a18",
            border: "1px solid #52c41a40",
            padding: "2px 8px",
            borderRadius: 20,
            flexShrink: 0,
          }}
        >
          Completado
        </span>
      )}
    </div>
  );
};

const DrawerEventsList = ({
  visible,
  titulo,
  eventos = [],
  onClose,
  onEventoClick,
  cargando = false,
  emptyText = "No hay eventos",
}) => (
  <Drawer
    open={visible}
    onClose={onClose}
    title={
      <span style={{ fontWeight: 600, fontSize: 15 }}>
        {titulo}
        {eventos.length > 0 && (
          <span
            style={{
              marginLeft: 8,
              fontSize: 12,
              fontWeight: 400,
              color: "#aaa",
            }}
          >
            ({eventos.length})
          </span>
        )}
      </span>
    }
    width={380}
    styles={{ body: { padding: "16px" } }}
  >
    <Spin spinning={cargando}>
      {!cargando && eventos.length === 0 ? (
        <div
          style={{
            color: "#bbb",
            textAlign: "center",
            marginTop: 40,
            fontSize: 13,
          }}
        >
          {emptyText}
        </div>
      ) : (
        eventos.map((ev, i) => (
          <EventoCard
            key={ev.id ?? ev._id ?? i}
            evento={ev}
            onClick={onEventoClick}
          />
        ))
      )}
    </Spin>
  </Drawer>
);

export default DrawerEventsList;